__turbopack_context__.v({
  "Active": "E0f_Oq_Active",
  "Events": "E0f_Oq_Events",
  "EventsWrapper": "E0f_Oq_EventsWrapper",
  "List": "E0f_Oq_List",
  "Placeholder": "E0f_Oq_Placeholder",
  "Started": "E0f_Oq_Started",
  "TabularNums": "E0f_Oq_TabularNums",
  "Timer": "E0f_Oq_Timer",
});
